import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './styles.css';

const Home = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  
  // Fonction pour basculer l'état du menu
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  
  // Fonction pour fermer le menu lors d'un clic sur un lien
  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <div className="page-container">
      <header className="header">
        <div className="logo">
          <h1>RENOV-PISCINES 13</h1>
        </div>
        <nav className={`navigation ${menuOpen ? 'mobile-menu-open' : ''}`}>
          <ul>
            <li><Link to="/" className="active" onClick={closeMenu}>Accueil</Link></li>
            <li><Link to="/projets" onClick={closeMenu}>Nos précédents chantiers</Link></li>
            <li><Link to="/contact" onClick={closeMenu}>Nous contacter</Link></li>
          </ul>
        </nav>
        <div className={`hamburger-menu ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </header>

      <main>
        <section className="hero">
          <div className="hero-content">
            <h2>Votre spécialiste en rénovation de piscines</h2>
            <p>Transformez votre piscine en un espace de rêve</p>
            <Link to="/contact" className="btn-primary">Demander un devis</Link>
          </div>
          <div className="hero-image">
            <div className="placeholder-image">
                <img src="/home-img.jpeg" className="hero-img" alt="Rénovation de piscine" />
            </div>
          </div>
        </section>

        <section className="services">
          <h2>Nos services</h2>
          <div className="services-container">
            <div className="service-card">
              <div className="service-icon">💧</div>
              <h3>Rénovation complète</h3>
              <p>Nous rénovons votre piscine de A à Z : revêtement, étanchéité, équipements. Offrez une nouvelle vie à votre bassin !</p>
            </div>

            <div className="service-card">
              <div className="service-icon">🔧</div>
              <h3>Pose PVC armé</h3>
              <p>Une solution durable et esthétique pour une étanchéité parfaite. Adapté à toutes les piscines, le PVC armé assure résistance et longévité.</p>
            </div>

            <div className="service-card">
              <div className="service-icon">✨</div>
              <h3>Modernisation</h3>
              <p>Mettez votre piscine au goût du jour : nouveaux équipements, éclairages LED, filtration améliorée… Plus de confort et d'économies !</p>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="about-content">
            <h2>À propos de RENOV-PISCINES 13</h2>
            <p>Depuis 2019, RENOV-PISCINES 13 redonne une seconde jeunesse à vos piscines. Nous prenons en charge la rénovation complète de votre bassin : du revêtement aux équipements, en passant par l'étanchéité et la structure.</p>
            <p>Nous intervenons dans tout le département des Bouches-du-Rhône (13) pour vous offrir une transformation sur mesure, adaptée à vos envies et aux normes actuelles.</p>
            <Link to="/projets" className="btn-secondary">Découvrir nos réalisations</Link>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-section">
            <h3>RENOV-PISCINES 13</h3>
            <p>Votre spécialiste de la rénovation de piscines dans les Bouches-du-Rhône.</p>
          </div>
          <div className="footer-section">
            <h3>Contact</h3>
            <p>Email: renovpiscines13@outlook.fr</p>
            <p>Téléphone: 06 51 51 29 93</p>
          </div>
          <div className="footer-section">
            <h3>Horaires</h3>
            <p>Lundi - Vendredi: 8h - 19h</p>
            <p>Samedi: 8h - 12h</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 RENOV-PISCINES 13. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;